import axios, { AxiosError } from 'axios';
import Cookies from 'js-cookie';

const axiosClient = axios.create({
  // Put your base URL here
  baseURL: 'https://api.anestesi-ui.id',
  // baseURL: 'https://backend-prod-9keh.onrender.com', // Render (lama)
  // baseURL: 'https://backend-dev-ruq1.onrender.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Interceptor for authentication
axiosClient.interceptors.request.use((config) => {
  const token = Cookies.get('jwt_token');

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `token ${token}`;
  }
  return config;
});

// Handle 401 error
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      const url = error.config?.url ?? '';
      const isLoginRequest = url.includes('/auth/login');

      // 401 pada request login = password salah, biarkan halaman login yang menangani.
      // 401 pada request lain = token kedaluwarsa -> tandai supaya halaman login
      // bisa memberi tahu user. Draft form kasus sudah tersimpan di localStorage
      // (lihat routes/AddCases/contexts/draft.ts) jadi tidak hilang saat reload.
      if (!isLoginRequest) {
        try {
          sessionStorage.setItem('session_expired', '1');
        } catch {
          // abaikan
        }
        Cookies.remove('jwt_token');
        window.history.pushState(null, '', '/login');
        window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);

export default axiosClient;
